import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';

import type {
  CreateModeloComunicacaoDto,
  ModeloComunicacao,
  ModeloDocumentoOption,
  UpdateModeloComunicacaoDto,
} from '../types/modeloComunicacaoTypes';

const BASE = '/admin/arbitral/comunicacao';

export const modelosComunicacaoService = {
  async listar(): Promise<ModeloComunicacao[]> {
    const data = await parseApiResponse<{ items: ModeloComunicacao[] }>(
      await apiGet(`${BASE}/modelos`),
    );
    return data.items;
  },

  async sincronizarMeta(): Promise<{ atualizados: number }> {
    return parseApiResponse<{ atualizados: number }>(await apiPost(`${BASE}/sync-meta`));
  },

  async listarModelosDocumento(): Promise<ModeloDocumentoOption[]> {
    const data = await parseApiResponse<{ items: ModeloDocumentoOption[] }>(
      await apiGet(`${BASE}/modelos-documento`),
    );
    return data.items;
  },

  async buscar(id: string): Promise<ModeloComunicacao> {
    return parseApiResponse<ModeloComunicacao>(await apiGet(`${BASE}/modelos/${id}`));
  },

  async criar(data: CreateModeloComunicacaoDto): Promise<ModeloComunicacao> {
    return parseApiResponse<ModeloComunicacao>(await apiPost(`${BASE}/modelos`, data));
  },

  async atualizar(id: string, data: UpdateModeloComunicacaoDto): Promise<ModeloComunicacao> {
    return parseApiResponse<ModeloComunicacao>(await apiPatch(`${BASE}/modelos/${id}`, data));
  },

  async alternarStatus(id: string): Promise<ModeloComunicacao> {
    return parseApiResponse<ModeloComunicacao>(await apiPatch(`${BASE}/modelos/${id}/status`));
  },
};
